// @unocss-include
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon } from '@a-type/ui';
import '@khmyznikov/pwa-install';
import { useSnapshot } from 'valtio';
import { installState, triggerInstall } from '../install.js';
import { getIsFirefox, getIsSafari, getOS } from '../platform.js';
import { PwaInstaller } from './PwaInstaller.js';
export function InstallButton(props) {
    const { installReady } = useSnapshot(installState);
    const onClick = () => {
        const os = getOS();
        if (getIsSafari() || getIsFirefox() || os === 'iOS' || os === 'Mac OS') {
            PwaInstaller.show();
        }
        else {
            triggerInstall();
        }
    };
    if (!installReady)
        return null;
    return (_jsx(_Fragment, { children: _jsx(Button, Object.assign({ color: "ghost", size: "small", onClick: onClick }, props, { children: props.children || (_jsxs(_Fragment, { children: [_jsx(Icon, { name: "arrowDown" }), _jsx("span", { children: "Install app" })] })) })) }));
}
export default InstallButton;
//# sourceMappingURL=InstallButton.js.map